import { render, staticRenderFns } from "./OrderHistory.html?vue&type=template&id=b2963ec8&scoped=true&"
import script from "./OrderHistory.ts?vue&type=script&lang=ts&"
export * from "./OrderHistory.ts?vue&type=script&lang=ts&"
import style0 from "./OrderHistory.css?vue&type=style&index=0&id=b2963ec8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2963ec8",
  null
  
)

export default component.exports